import { lifecycle } from 'recompose';

export default (className, rootClassName) =>
  lifecycle({
    componentDidMount: () => {
      rootClassName && document.documentElement.classList.add(rootClassName);
      document.body.classList.add(className);
    },

    componentWillUnmount: () => {
      rootClassName && document.documentElement.classList.remove(rootClassName);
      document.body.classList.remove(className);
    },
  });
